import { alpha, darken } from '@mui/material/styles';

const DEFAULT_BRAND = '#F57C20';

const getLoginTokens = (dark, brand) => {
  const b = brand || DEFAULT_BRAND;
  return {
    primary: b,
    primaryHover: darken(b, 0.15),
    textPrimary: dark ? '#e2e8f0' : '#1a1a2e',
    textSecondary: dark ? '#94a3b8' : '#6b7280',
    inputBg: dark ? 'rgba(255,255,255,0.08)' : '#ffffff',
    inputBorder: dark ? 'rgba(148,163,184,0.25)' : '#e5e7eb',
    inputBorderHover: dark ? 'rgba(148,163,184,0.4)' : '#d1d5db',
    focusShadow: dark ? alpha(b, 0.18) : alpha(b, 0.1),
    placeholder: dark ? '#64748b' : '#b0b8c4',
    icon: dark ? '#94a3b8' : '#c0c7d0',
    divider: dark ? 'rgba(148,163,184,0.15)' : '#e5e7eb',
    iconHoverBg: dark ? alpha(b, 0.12) : alpha(b, 0.08),
    btnShadow: alpha(b, 0.35),
    gradientTint: dark ? alpha(b, 0.06) : alpha(b, 0.04),
    gradientTintSoft: dark ? alpha(b, 0.04) : alpha(b, 0.03),
  };
};

export default getLoginTokens;
